import React, {useState} from 'react';
import NominateModal from './nominateModal';
import styles from'./nominate.module.css';

const NominateSuccess = () => {


  return (
    <div className={styles.mainmodalwrapper}>
      <NominateModal />
    </div>
  );
}

export default NominateSuccess